module.exports = __webpack_public_path__ + "media/keyboard_click.6131d222.mp3";